/*
 * CardsByBeard — cart extras
 * - "Verzekerd verstuurd" balk(en) live bijwerken (drawer + /cart)
 * - Productsuggestie in de cart drawer ("Misschien ook leuk")
 * - window.cbAddToCart(): toevoegen + drawer & winkelwagen-teller verversen zoals Dawn doet
 * - Mobiele afrekenbalk op /cart
 */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function formatMoney(cents) {
    var parts = (cents / 100).toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '€' + parts[0] + ',' + parts[1];
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ── Shipping bar ─────────────────────────────────── */
  function updateShippingBars(totalCents) {
    document.querySelectorAll('[data-cb-shipping-bar]').forEach(function (bar) {
      var threshold = parseInt(bar.dataset.threshold, 10) || 15000;
      var reached = totalCents >= threshold;
      var textEl = bar.querySelector('.cb-shipping-bar__text');
      var fill = bar.querySelector('.cb-shipping-bar__fill');

      if (fill) fill.style.width = Math.min(100, (totalCents / threshold) * 100) + '%';
      bar.classList.toggle('cb-shipping-bar--reached', reached);
      if (!textEl) return;
      textEl.classList.toggle('cb-shipping-bar__text--reached', reached);
      textEl.innerHTML = reached
        ? '🎉 Je bestelling wordt verzekerd verstuurd!'
        : 'Nog <strong>' + formatMoney(threshold - totalCents) + '</strong> tot verzekerd verstuurd';
    });
  }

  // Dawn: PUB_SUB_EVENTS (constants.js) is een top-level const, publish/subscribe komen uit pubsub.js
  function hasPubSub() {
    return typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish === 'function' && typeof subscribe === 'function';
  }

  /* ── Herkomst van toevoegingen ("_bron") ────────────
   * Elke productlijst heeft data-cb-source (bijv. "Homepage › Nieuw binnen").
   * Het label gaat als verborgen regel-eigenschap _bron mee (klant ziet het niet, jij wel in de bestelling).
   */
  var cartLines = []; // laatste stand van /cart.js
  var VIA_KEY = 'cb_via';

  function sourceFor(el) {
    var holder = el && el.closest ? el.closest('[data-cb-source]') : null;
    var label = holder ? (holder.getAttribute('data-cb-source') || '').trim() : '';
    return label || 'Onbekend';
  }
  window.cbSourceFor = sourceFor;

  // Staat dezelfde variant al in de winkelwagen? Dan exact dezelfde eigenschappen meesturen,
  // anders maakt Shopify er twee aparte regels van. De eerste herkomst blijft dan staan.
  function propsFor(variantId, props) {
    var id = Number(variantId);
    var existing = cartLines.filter(function (line) {
      return line.variant_id === id;
    })[0];
    if (existing) {
      return existing.properties && Object.keys(existing.properties).length ? existing.properties : null;
    }
    return props || null;
  }
  window.cbPropsFor = propsFor;

  // Onthoud via welke lijst iemand op een product klikte (voor de productpagina)
  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest && event.target.closest('a[href*="/products/"]');
      if (!link) return;
      var holder = link.closest('[data-cb-source]');
      if (!holder) return;
      try {
        var handle = new URL(link.href, window.location.href).pathname.split('/products/')[1] || '';
        sessionStorage.setItem(VIA_KEY, JSON.stringify({ src: sourceFor(link), handle: handle.split('/')[0] }));
      } catch (err) {}
    },
    true
  );

  // Productpagina: "Productpagina" aanvullen met waar de klant vandaan kwam
  function fillProductSource() {
    var inputs = document.querySelectorAll('[data-cb-source-input]');
    if (!inputs.length) return;
    var suffix = 'direct';
    try {
      var via = JSON.parse(sessionStorage.getItem(VIA_KEY) || 'null');
      var handle = (window.location.pathname.split('/products/')[1] || '').split('/')[0];
      if (via && via.src && via.handle && via.handle === handle) {
        suffix = 'via ' + via.src;
      } else if (document.referrer) {
        var ref = new URL(document.referrer);
        suffix = ref.hostname === window.location.hostname ? 'via interne link' : 'via ' + ref.hostname.replace(/^www\./, '');
      }
    } catch (err) {}
    inputs.forEach(function (input) {
      if (!input.dataset.base) input.dataset.base = input.value;
      input.value = input.dataset.base + ' (' + suffix + ')';
    });
  }

  // Productformulier: bij een variant die al in de winkelwagen zit dezelfde eigenschappen meesturen
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      var input = form && form.querySelector ? form.querySelector('[data-cb-source-input]') : null;
      if (!input) return;
      form.querySelectorAll('[data-cb-prop-clone]').forEach(function (el) {
        el.remove();
      });
      var idInput = form.querySelector('[name="id"]');
      var existing = idInput
        ? cartLines.filter(function (line) {
            return line.variant_id === Number(idInput.value);
          })[0]
        : null;
      input.disabled = !!existing;
      if (!existing || !existing.properties) return;
      Object.keys(existing.properties).forEach(function (key) {
        var clone = document.createElement('input');
        clone.type = 'hidden';
        clone.name = 'properties[' + key + ']';
        clone.value = existing.properties[key];
        clone.setAttribute('data-cb-prop-clone', '');
        form.appendChild(clone);
      });
    },
    true
  );

  /* ── Add to cart (gedeeld door alle upsells) ──────── */
  function refreshBubble(html) {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble || !html) return;
    var source = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
    if (source) bubble.innerHTML = source.innerHTML;
  }

  window.cbAddToCart = function (variantId, quantity, properties) {
    var cartDrawer = document.querySelector('cart-drawer');
    var body = {
      id: variantId,
      quantity: quantity || 1,
      sections: 'cart-drawer,cart-icon-bubble',
      sections_url: window.location.pathname,
    };
    var finalProps = propsFor(variantId, properties);
    if (finalProps) body.properties = finalProps;

    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || data.status) throw data;
          return data;
        });
      })
      .then(function (state) {
        if (cartDrawer && typeof cartDrawer.renderContents === 'function' && state.sections) {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(state);
        } else if (state.sections) {
          refreshBubble(state.sections['cart-icon-bubble']);
        }
        if (hasPubSub()) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cb-upsell',
            productVariantId: variantId,
            cartData: state,
          });
        }
        scheduleUpdate();
        return state;
      });
  };

  /* ── Upsell in cart drawer ────────────────────────── */
  var recommendationCache = {};

  function getRecommendations(productId) {
    if (!recommendationCache[productId]) {
      recommendationCache[productId] = fetch(
        root + 'recommendations/products.json?product_id=' + productId + '&limit=6&intent=related'
      )
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          return data.products || [];
        })
        .catch(function () {
          delete recommendationCache[productId];
          return [];
        });
    }
    return recommendationCache[productId];
  }

  function hideUpsell(el) {
    el.hidden = true;
    el.innerHTML = '';
  }

  function renderUpsell(cart) {
    var el = document.getElementById('cb-cart-upsell');
    if (!el) return;
    if (!cart.items || !cart.items.length) return hideUpsell(el);

    var inCart = cart.items.map(function (item) {
      return item.product_id;
    });

    // Eerst de suggestie volgens de upsell-regels (door snippets/cart-drawer.liquid klaargezet)
    var keuze = null;
    try {
      var keuzeEl = document.getElementById('cb-upsell-keuze');
      keuze = keuzeEl ? JSON.parse(keuzeEl.textContent) : null;
    } catch (e) {
      keuze = null;
    }
    if (keuze && inCart.indexOf(keuze.id) === -1) {
      toonUpsell(el, {
        id: keuze.id,
        title: keuze.title,
        url: keuze.url,
        image: keuze.image ? (keuze.image.indexOf('//') === 0 ? 'https:' + keuze.image : keuze.image) : '',
        price: keuze.price,
        variantId: keuze.variant,
        van: keuze.van,
      });
      return;
    }

    getRecommendations(cart.items[0].product_id).then(function (products) {
      // Element kan intussen door Dawn vervangen zijn → opnieuw opzoeken
      var target = document.getElementById('cb-cart-upsell');
      if (!target) return;

      var product = products.filter(function (p) {
        return p.available && inCart.indexOf(p.id) === -1;
      })[0];
      if (!product) return hideUpsell(target);
      if (target.dataset.shownProductId === String(product.id) && !target.hidden) return;

      var variant =
        product.variants.filter(function (v) {
          return v.available;
        })[0] || product.variants[0];
      var imgUrl = product.featured_image
        ? product.featured_image + (product.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=120'
        : '';

      toonUpsell(target, {
        id: product.id,
        title: product.title,
        url: product.url,
        image: imgUrl,
        price: variant.price,
        variantId: variant.id,
        van: 'cart-drawer',
      });
    });
  }

  // Toont één suggestie in de winkelwagenlade
  function toonUpsell(target, product) {
    if (target.dataset.shownProductId === String(product.id) && !target.hidden) return;
    var imgUrl = product.image;
    var variant = { id: product.variantId, price: product.price };
    target.innerHTML =
      '<span class="cb-upsell__label">Misschien ook leuk</span>' +
      '<div class="cb-upsell__card">' +
      '<a href="' + escapeHtml(product.url) + '" class="cb-upsell__img" tabindex="-1" aria-hidden="true">' +
      (imgUrl ? '<img src="' + escapeHtml(imgUrl) + '" alt="" width="58" height="58" loading="lazy">' : '') +
      '</a>' +
      '<div class="cb-upsell__info">' +
      '<a href="' + escapeHtml(product.url) + '" class="cb-upsell__title">' + escapeHtml(product.title) + '</a>' +
      '<p class="cb-upsell__price">' + formatMoney(variant.price) + '</p>' +
      '</div>' +
      '<button type="button" class="cb-upsell__btn" aria-label="' +
      escapeHtml(product.title) + ' toevoegen aan winkelwagen">+ Voeg toe</button>' +
      '</div>';
    target.dataset.shownProductId = String(product.id);
    target.hidden = false;

    var btn = target.querySelector('.cb-upsell__btn');
    btn.addEventListener('click', function () {
      btn.disabled = true;
      btn.textContent = '...';
      window
        .cbAddToCart(variant.id, 1, {
          _bron: 'Winkelwagen-lade › Misschien ook leuk',
          _upsell: 'Ja',
          _upsell_van: product.van || 'cart-drawer',
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = 'Probeer opnieuw';
        });
    });
  }

  /* ── Centrale update (gedebounced) ────────────────── */
  var updateTimer = null;

  function update() {
    fetch(root + 'cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        cartLines = cart.items || [];
        updateShippingBars(cart.total_price);
        renderUpsell(cart);
      })
      .catch(function () {});
  }

  function scheduleUpdate() {
    clearTimeout(updateTimer);
    updateTimer = setTimeout(update, 150);
  }

  function isOwnMutation(record) {
    var node = record.target;
    return !!(node && node.closest && node.closest('#cb-cart-upsell, [data-cb-shipping-bar]'));
  }

  function init() {
    // Dawn publiceert cartUpdate bij toevoegen / aantal wijzigen / verwijderen
    if (hasPubSub()) subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleUpdate);

    // Vangnet: Dawn herschrijft de drawer-inhoud → opnieuw vullen
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      new MutationObserver(function (records) {
        if (records.every(isOwnMutation)) return;
        scheduleUpdate();
      }).observe(drawer, { childList: true, subtree: true });

      var wasActive = drawer.classList.contains('active');
      new MutationObserver(function () {
        var isActive = drawer.classList.contains('active');
        if (isActive && !wasActive) scheduleUpdate();
        wasActive = isActive;
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }

    var mainCartItems = document.getElementById('main-cart-items');
    if (mainCartItems) {
      new MutationObserver(function (records) {
        if (records.every(isOwnMutation)) return;
        scheduleUpdate();
      }).observe(mainCartItems, { childList: true, subtree: true });
    }

    if (drawer && drawer.querySelector('.cart-item')) scheduleUpdate();

    initStickyCheckout();
    fillProductSource();
  }

  /* ── Cart pagina (mobiel): afrekenbalk zolang de afrekenknop nog onder de vouw zit ── */
  function initStickyCheckout() {
    var checkout = document.getElementById('checkout');
    if (!checkout) return;
    var html = document.documentElement;
    var queued = false;

    function check() {
      queued = false;
      var rect = checkout.getBoundingClientRect();
      // Verborgen (lege cart) → rect is 0 → balk uit
      html.classList.toggle('cb-cart-sticky-on', rect.height > 0 && rect.top > window.innerHeight);
    }

    function queue() {
      if (queued) return;
      queued = true;
      setTimeout(check, 80);
    }

    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    window.addEventListener('load', queue);
    if (hasPubSub()) subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(queue, 300); });
    queue();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
